import { z } from 'zod';

export const contactInfoSchema = z.object({
    fullName: z.string().min(1, 'Full name is required'),
    email: z.string().email('Invalid email address'),
    contactNumber: z.string().min(1, 'Contact number is required'),
});

export const passwordSchema = z.object({
    currentPassword: z.string().min(1, 'Current password is required'),
    newPassword: z.string().min(6, 'Password must be at least 6 characters'),
    confirmPassword: z.string().min(1, 'Please confirm your password'),
}).refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
});

export const studentProfileSchema = z.object({
    fullName: z.string().min(1, 'Full name is required'),
    grade: z.string().min(1, 'Grade is required'),
    section: z.string().min(1, 'Section is required'),
});

export const teacherProfileSchema = z.object({
    fullName: z.string().min(1, 'Full name is required'),
});

export type ContactInfoFormValues = z.infer<typeof contactInfoSchema>;
export type StudentProfileFormValues = z.infer<typeof studentProfileSchema>;
export type TeacherProfileFormValues = z.infer<typeof teacherProfileSchema>;
export type PasswordFormValues = z.infer<typeof passwordSchema>;
